import { render } from "./OffersItem.vue?vue&type=template&id=570694d5&scoped=true"
import script from "./OffersItem.vue?vue&type=script&lang=js"
export * from "./OffersItem.vue?vue&type=script&lang=js"

import "./OffersItem.vue?vue&type=style&index=0&id=570694d5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-570694d5"

export default script